
export const myMixin = {

    created(){
        //console.log('hi there mixin is on...');
    },

    methods : {

    truncator(numToTruncate, intDecimalPlaces) {    
        var numPower = Math.pow(10, intDecimalPlaces); // "numPowerConverter" might be better
        return ~~(numToTruncate * numPower)/numPower;
    },

      formataMoeda(valor){
          if(valor != null && valor != ''){
            return valor.toLocaleString('pt-br', {minimumFractionDigits: 2});
          }
      },

      formataNumeroBR(valor){
        if(valor != null && valor != ''){
          return valor.toLocaleString('pt-br', {minimumFractionDigits: 0});
        }
    },

      formataData(myDate){
        if(myDate){
            return String(myDate.getDate()).padStart(2, '0') + '/' + String(myDate.getMonth() + 1). padStart(2, '0') + '/' + myDate.getFullYear();
        }
        return null;
      },

      getLinhaFormatada(esporte, serieTreino){
        
        //console.log(JSON.stringify(serieTreino));

        if(esporte && (esporte == 'Corrida' ||  esporte == 'Ciclismo') && serieTreino.tipoTreino == 'Pace'){

            let result = '';
            if(serieTreino.distanciaKm){
                result += serieTreino.distanciaKm + ' km em ';
            }
            if(serieTreino.paceMinutos){
                result += this.fillZeros(serieTreino.paceMinutos);
            }
            if(serieTreino.paceMinutos && serieTreino.paceSegundos){
                result += ':'
            }
            if(!serieTreino.paceMinutos && serieTreino.paceSegundos){
                result += '00:'
            }
            if(serieTreino.paceSegundos){
                result += this.fillZeros(serieTreino.paceSegundos);
            }
            result += ' min (a ' + serieTreino.calculatedPace + ' ' + serieTreino.medida + ')';
            if(serieTreino.descanso){
                result += ' + descansa ' + serieTreino.descanso + ' seg';
            }
            return result;

        }else if(esporte && serieTreino.tipoTreino == 'Frequência'){

            let result = '';
            if(serieTreino.tempo && serieTreino.tempoSegundos){
                result += serieTreino.tempo + ':' + this.fillZeros(serieTreino.tempoSegundos) + ' min';
            }
            else if(serieTreino.tempo && !serieTreino.tempoSegundos){
                result += serieTreino.tempo + ' min';
            }
            else if(!serieTreino.tempo && serieTreino.tempoSegundos){
                result += serieTreino.tempoSegundos + ' seg ';
            }else{
                result += 'tempo indefinido';
            }

            if(serieTreino.volume){
                result += ', com ' + serieTreino.volume + '% '
            }
            if(serieTreino.descanso){
                result += ' + descansa ' + serieTreino.descanso + ' seg';
            }

            return result;    

        } else if(serieTreino.tipoTreino && serieTreino.tipoTreino == 'Potência'){

            let result = '';
            if(serieTreino.tempo && serieTreino.tempoSegundos){
                result += serieTreino.tempo + ':' + this.fillZeros(serieTreino.tempoSegundos) + ' min, com ' + serieTreino.volume + ' watts';
            }
            else if(serieTreino.tempo && !serieTreino.tempoSegundos){
                result += serieTreino.tempo + ' min, com ' + serieTreino.volume + ' watts';
            }
            else if(!serieTreino.tempo && serieTreino.tempoSegundos){
                result += serieTreino.tempoSegundos + ' seg, com ' + serieTreino.volume + ' watts';
            }else{
                result += 'tempo indefinido, com ' + serieTreino.volume + ' watts';
            }

            if(serieTreino.descanso){
                result += ' + descansa ' + serieTreino.descanso + ' seg';
            }
            return result;
            
        } else if(esporte && esporte == 'Natação' && serieTreino.tipoTreino != 'Frequência'){

            let result = '';
            if(serieTreino.metrosNatacao){
                result += serieTreino.metrosNatacao + 'm (' + serieTreino.calculatedPace + ' ' + serieTreino.medida + ")";
            }else{
                result += serieTreino.distanciaKm + ' km (' + serieTreino.calculatedPace + ' ' + serieTreino.medida + ")";
            }

            if(serieTreino.descanso){
                result += ' + descansa ' + serieTreino.descanso + ' seg';
            }
            return result;
        }
    },

    getLinhaFormatadaHTML(esporte, serieTreino){
        
       let result = this.getLinhaFormatada(esporte, serieTreino);
       if(result && result.length > 50){
           let resultSplitted = (result.substring(0, result.indexOf('+'))) + '<br />&nbsp;&nbsp;&nbsp;&nbsp;' + result.substring(result.indexOf('+'));
           return resultSplitted;
       }
       return result;
    },

    fillZeros(myValue){
        //console.log('aquiz ' + myValue + ' length: ' + myValue.toString().length);
        if(myValue && myValue.toString().length < 2){
            return '0' + myValue.toString();
        }
        return myValue;
    },

        
  },

    
}